export class AuditPartition {
    partitionId: number;
    ruleId: number;
    ruleType: string;
}